import { useSelector } from 'react-redux';
import AppRouter from 'common/AppRouter';
import Contributor from './Contributor';
import Teams from './Teams';
import { isTeamLicenseSelector } from 'state/selectors/license';
import { isAdmin, isSuperUser } from 'common/services/accounts.service';
import { FEATURE_FLAGS_NAMES } from '@linearb/linjs-common';
import { myAccountSelector } from 'state/selectors/account';
import useSettingsService from 'components/hooks/useSettingsService';
import {
  Link,
  Routes,
  Route,
  useLocation,
  Navigate
} from 'react-router-dom-v5-compat';
import { LBTabs, LBTabsList, LBTabsTrigger } from '@linearb/buzz';
import { UserManagement } from './UserManagement';

function ContributorsAndTeamsSettings() {
  const location = useLocation();
  const isTeamLicense = useSelector(isTeamLicenseSelector);

  const myAccount = useSelector(myAccountSelector);
  const { getSettingOrDefinitionValue } = useSettingsService();
  const isRBACEnabledFF = getSettingOrDefinitionValue({
    name: FEATURE_FLAGS_NAMES.isRBACEnabled
  });
  const newUserManagementEnabled = getSettingOrDefinitionValue({
    name: FEATURE_FLAGS_NAMES.newUserManagementEnabled
  });

  const canAccessContributorsAndUsersPage =
    isRBACEnabledFF && !isTeamLicense
      ? isAdmin(myAccount) || isSuperUser(myAccount)
      : true;

  return (
    <>
      {!isTeamLicense && (
        <LBTabs className='inline-block' value={location.pathname}>
          <LBTabsList>
            <LBTabsTrigger
              data-testid='tab'
              value={AppRouter.TEAMS_SETTINGS.path}
              asChild
            >
              <Link
                to={{
                  pathname: AppRouter.TEAMS_SETTINGS.path,
                  search: new URLSearchParams({
                    isOrgSettings: 'true'
                  }).toString()
                }}
              >
                Teams
              </Link>
            </LBTabsTrigger>

            {canAccessContributorsAndUsersPage && (
              <>
                <LBTabsTrigger
                  data-testid='tab'
                  value={AppRouter.CONTRIBUTORS_SETTINGS.path}
                  asChild
                >
                  <Link
                    to={{
                      pathname: AppRouter.CONTRIBUTORS_SETTINGS.path,
                      search: new URLSearchParams({
                        isOrgSettings: 'true'
                      }).toString()
                    }}
                  >
                    Contributors
                  </Link>
                </LBTabsTrigger>
                {newUserManagementEnabled && (
                  <LBTabsTrigger
                    data-testid='tab'
                    value={AppRouter.USER_SETTINGS.path}
                    asChild
                  >
                    <Link to={AppRouter.USER_SETTINGS.path}>
                      Users (preview)
                    </Link>
                  </LBTabsTrigger>
                )}
              </>
            )}
          </LBTabsList>
        </LBTabs>
      )}

      <Routes>
        <Route
          index
          path={AppRouter.USER_SETTINGS.path}
          element={<UserManagement />}
        />

        <Route index path={AppRouter.TEAMS_SETTINGS.path} element={<Teams />} />

        {canAccessContributorsAndUsersPage && (
          <Route
            path={AppRouter.CONTRIBUTORS_SETTINGS.path}
            element={<Contributor />}
          />
        )}

        <Route
          path='*'
          element={
            <Navigate
              to={{
                pathname: newUserManagementEnabled
                  ? AppRouter.USER_SETTINGS.path
                  : AppRouter.TEAMS_SETTINGS.path,
                search: new URLSearchParams({
                  isOrgSettings: 'true'
                }).toString()
              }}
              replace
            />
          }
        />
      </Routes>
    </>
  );
}

export default ContributorsAndTeamsSettings;
